import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'mat-star-rating',
    templateUrl: 'mat-star-rating.component.html',
    styleUrls: ['mat-star-rating.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class MatStarRatingComponent implements OnInit {

    @Input('rating') public rating: number = 3;
    @Input('starCount') public starCount: number = 5;
    @Input('color') public color: string = 'accent';
    @Output() public ratingUpdated = new EventEmitter();
  
    public snackBarDuration: number = 2000;
    public ratingArr = [];
  
    constructor() {
    }
  
  
    ngOnInit() {
      console.log("a "+this.starCount)
      for (let index = 0; index < this.starCount; index++) {
        this.ratingArr.push(index);
      }
    }
    onClick(rating:number) {
      this.ratingUpdated.emit(rating);
      return false;
    }
  
    showIcon(index:number) {
      if (this.rating >= index + 1) {
        return true;
      } else {
        return false;
      }
    }
  
  }
  export enum StarRatingColor {
    primary = "primary",
    accent = "accent",
    warn = "warn"
  }
  
